import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';
import { SafeHtmlPipe } from '@app/core/security/safe-html.pipe';

@Component({
  selector: 'app-notification-popup',
  standalone: true,
  imports: [SafeHtmlPipe],
  template: `
    <section class="popup" role="document">
      <header>
        <p class="category">{{ categoryLabel || 'お知らせ' }}</p>
        <h2 id="notification-popup-title">{{ title }}</h2>
      </header>

      <div
        id="notification-popup-message"
        class="message"
        [innerHTML]="body | safeHtml"
      ></div>

      <div class="actions">
        <button type="button" class="close" (click)="dismiss('close')">閉じる</button>
        <button type="button" class="details" (click)="dismiss('details')">詳しく見る</button>
      </div>
    </section>
  `,
  styles: [`
    :host {
      position: relative;
      contain: content;
      display: block;
      min-height: 0;
      background: var(--pb-overlay-surface, #fff);
      color: var(--pb-overlay-text, #2a2430);
    }
    .popup { display: grid; grid-template-rows: auto minmax(0, 1fr) auto; max-height: calc(100dvh - 48px); padding: 26px; }
    header { min-width: 0; padding-bottom: 18px; }
    .category { margin: 0 0 6px; color: var(--pb-overlay-primary, #6a4c93); font-size: 11px; font-weight: 800; line-height: 1.4; }
    h2 { margin: 0; color: var(--pb-overlay-text, #2a2430); font-size: 18px; font-weight: 800; line-height: 1.55; overflow-wrap: anywhere; }
    .message { min-height: 0; overflow-y: auto; padding: 18px 0; border-top: 1px solid var(--pb-overlay-border, #ebe9ed); border-bottom: 1px solid var(--pb-overlay-border, #ebe9ed); color: #453d4c; font-size: 14px; line-height: 1.85; overflow-wrap: anywhere; }
    .message :first-child { margin-top: 0; }
    .message :last-child { margin-bottom: 0; }
    .message img { max-width: 100%; height: auto; }
    .actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 20px; }
    button { min-height: 48px; padding: 12px 16px; border: 1px solid var(--pb-overlay-border-strong, #dcd7e1); border-radius: 12px; background: #fff; color: var(--pb-overlay-muted, #655e6c); font: inherit; font-size: 14px; font-weight: 700; cursor: pointer; }
    button.details { border-color: var(--pb-overlay-primary, #6a4c93); background: var(--pb-overlay-primary, #6a4c93); color: #fff; }
    button.details:hover, button.details:active { background: var(--pb-overlay-primary-dark, #4b3670); }
    button:focus-visible { outline: 3px solid #087a75; outline-offset: 3px; }
    @media (max-width: 340px) {
      .popup { padding: 22px 20px 20px; }
      .actions { grid-template-columns: 1fr; }
      button.details { grid-row: 1; }
    }
  `],
})
export class NotificationPopupComponent {
  @Input() title = '';
  @Input() body = '';
  @Input() categoryLabel: string | null = null;

  private readonly modalController = inject(ModalController);

  async dismiss(role: 'close' | 'details'): Promise<void> {
    await this.modalController.dismiss(undefined, role);
  }
}
